/**
 * Hook for handling links in embedded mode
 *
 * All internal links should open in new tab to prevent iframe navigation issues.
 * External links also open in new tab for consistency.
 */

import { useEffect } from 'react';

export function useEmbeddedLinksHandler() {
  useEffect(() => {
    // Global click handler for all <a> tags in embedded mode
    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // Find parent <a> tag if click was on child element
      const link = target.closest('a');

      if (link && link.href) {
        // Prevent default navigation in iframe
        event.preventDefault();

        // Open link in new tab
        window.open(link.href, '_blank', 'noopener,noreferrer');
      }
    };

    // Attach global event listener
    document.addEventListener('click', handleClick, true); // Use capture phase

    // Cleanup on unmount
    return () => {
      document.removeEventListener('click', handleClick, true);
    };
  }, []);
}
